var cloudflareTurnstile = function () {

    var publicMethods = {};
    var checkIntervalInMilliseconds = 1000;
    var checkLimitBeforeShowingError = 5;

    var turnstileWarningDataAttribute = 'data-turnstile-warning';
    var warnings;

    publicMethods.init = function () {

        warnings = document.querySelectorAll('[' + turnstileWarningDataAttribute + ']');
        if (!warnings.length) return;
        if (turnstileDefined()) return;

        check();

    };

    function check() {

        var numberOfChecks = 0;

        var checkInterval = setInterval(function () {

            if (numberOfChecks >= checkLimitBeforeShowingError) showWarnings();

            if (turnstileDefined()) {

                hideWarnings();
                clearInterval(checkInterval);

            }

            numberOfChecks++;

        }, checkIntervalInMilliseconds); 

    };

    function turnstileDefined() {

        return typeof window.turnstile !== "undefined";

    };

    function showWarnings() {

        for (var i = 0; i < warnings.length; i++) {

            (function (i) {

                warnings[i].style.display = 'block';

            })(i);

        }

    };

    function hideWarnings() {

        for (var i = 0; i < warnings.length; i++) {

            (function (i) {

                warnings[i].style.display = null;

            })(i);

        }

    };

    return publicMethods;

}();

cloudflareTurnstile.init();
